import { createSlice } from '@reduxjs/toolkit';

// Optimistic default: assume available until ChatWidgetHost's script
// load/init attempt proves otherwise, so the button/component render on
// first paint instead of waiting for the network round-trip.
const initialState = {
  isAvailable: true,
};

const chatWidgetSlice = createSlice({
  name: 'chatWidget',
  initialState,
  reducers: {
    setChatWidgetAvailable: (state) => {
      state.isAvailable = true;
    },
    setChatWidgetUnavailable: (state) => {
      state.isAvailable = false;
    },
  },
});

export const chatWidgetActions = chatWidgetSlice.actions;
export default chatWidgetSlice.reducer;
